module.exports = __webpack_public_path__ + "img/bg_function05_2_d.8c16f810.svg";